import { prop, join, compose, curry } from 'ramda';

import { getLocale } from './i18n';

export const getLoaders = prop('loaders');

export const getLocalized = (state) => prop(getLocale(state));

export const getDocByIdLoader = curry((id, state) =>
  compose(prop(id), getLocalized(state), prop('loadDocById'), getLoaders)(state)
);

export const getDocByUidLoader = curry((type, uid, state) =>
  compose(
    prop(`${type}-${uid}`),
    getLocalized(state),
    prop('loadDocByUid'),
    getLoaders
  )(state)
);

export const getDocsByIdsLoader = curry((ids, state) =>
  compose(
    prop(join(',', ids)),
    getLocalized(state),
    prop('loadDocByIds'),
    getLoaders
  )(state)
);

export const getSingleTypeDocLoader = curry((type, state) =>
  compose(
    prop(type),
    getLocalized(state),
    prop('loadDocByType'),
    getLoaders
  )(state)
);

export const getDocLoader = curry((key, state) =>
  compose(prop(key), getLocalized(state), prop('loadDoc'), getLoaders)(state)
);

export const getDocsLoader = curry((key, state) =>
  compose(prop(key), getLocalized(state), prop('loadDocs'), getLoaders)(state)
);
